import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updateArtCustom = /* GraphQL */ `mutation UpdateArtCustom(
  $input: UpdateArtInput!
  $condition: ModelArtConditionInput
) {
  updateArt(input: $input, condition: $condition) {
    id
    feeling
    subject
    subOption
    medium
    styles
    color
    like
    approve
    deleted
    createdAt
    updatedAt
    s3Image {
      bucket
      region
      key
    },
  }
}
` as GeneratedMutation<
  APITypes.UpdateArtMutationVariables,
  APITypes.UpdateArtMutation
>;



export const createArtCustom = /* GraphQL */ `mutation createArtCustom(
  $input: CreateArtInput!
  $condition: ModelArtConditionInput
) {
  createArt(input: $input, condition: $condition) {
    id
    userId
    createdAt
    title
    inputImage
    s3Image {
      bucket
      region
      key
      __typename
    }
    prompt
    revisedPrompt
    subject
    subjectText
    subOption
    styles
    stylesText
    color
    colorText
    medium
    mediumText
    model
    feeling
    feelingText
    like
    approve
    deleted
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateArtMutationVariables,
  APITypes.CreateArtMutation
>;

export const updateUserCustom = /* GraphQL */ `mutation updateUserCustom(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    email
    username
    emailVerified
    identityId
    credits
    boughtCredits
    creditPurchases {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        creditAmount
        checkoutSessionId
        paymentIntentId
        owner
        updatedAt
        userCreditPurchasesId
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;